import { useState } from "react";
import { FaChevronDown } from "react-icons/fa";

const ItineraryContentCampaign = ({ itinerary, isSignificant }) => {
  const [openIndex, setOpenIndex] = useState(0);

  if (
    !Array.isArray(itinerary) ||
    itinerary.every((item) => !item?.day && !item?.heading && !item?.content)
  ) {
    return null;
  }

  const toggleSection = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <>
      <div className="mt-6 flex flex-col gap-4 sm:mt-8 w-full">
        {itinerary.map((section, index) => {
          const isOpen = openIndex === index;

          return (
            <div
              key={index}
              className="border border-gray-200 shadow-xl hover:border-gray-300 rounded-md px-5 py-3 
                          transition-all duration-300 ease-in-out 
                          hover:shadow-2xl hover:-translate-y-1 hover:scale-[1.01] hover:bg-gray-50"
            >
              {/* HEADER (CLICKABLE) */}
              <div
                onClick={() => toggleSection(index)}
                className="flex justify-between items-center cursor-pointer"
              >
                <h2 className="text-lg sm:text-xl md:text-base font-bold text-white px-4 py-2 bg-[#02323F] rounded-lg">
                  {section.day}
                </h2>

                <FaChevronDown
                  className={`transition-transform duration-300 ${
                    isOpen ? "rotate-180 text-sm text-[#02323F]" : "text-sm"
                  }`}
                />
              </div>

              {/* CONTENT */}
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  isOpen ? "max-h-[2000px] mt-4" : "max-h-0"
                }`}
              >
                <div className="flex flex-col gap-4 sm:gap-6">
                  {/* TITLE */}
                  <h3 className="text-lg sm:text-xl font-semibold text-gray-700">
                    {section.heading}
                  </h3>

                  {/* DESCRIPTION */}
                  <div className="text-sm sm:text-base text-gray-700 leading-relaxed">
                    <div
                      dangerouslySetInnerHTML={{
                        __html: section.content,
                      }}
                    />
                  </div>

                  {/* IMAGES */}
                  {section.infoImages?.length > 0 && (
                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-4">
                      {section.infoImages.map((img, i) => (
                        <div
                          key={i}
                          className={`overflow-hidden rounded-lg shadow-sm hover:shadow-md ${
                            section.infoImages.length === 1
                              ? ""
                              : "aspect-square"
                          }`}
                        >
                          <img
                            src={img}
                            alt=""
                            className="w-full h-full object-cover rounded-lg hover:scale-105 transition-transform duration-300"
                            loading="lazy"
                          />
                        </div>
                      ))}
                    </div>
                  )}

                  {/* VIDEOS */}
                  {section.videoURL?.length > 0 && (
                    <div className="flex flex-col gap-4">
                      {section.videoURL.map((vid, i) => {
                        if (!vid) return null;

                        const isYoutube =
                          vid.includes("youtube.com") ||
                          vid.includes("youtu.be");

                        let youtubeId = "";

                        if (vid.includes("watch?v=")) {
                          youtubeId = vid.split("watch?v=")[1]?.split("&")[0];
                        } else if (vid.includes("youtu.be/")) {
                          youtubeId = vid.split("youtu.be/")[1]?.split("?")[0];
                        }

                        return (
                          <div key={i}>
                            {isYoutube && youtubeId ? (
                              <iframe
                                className="w-full h-[300px] sm:h-[400px] rounded-lg"
                                src={`https://www.youtube.com/embed/${youtubeId}`}
                                title="YouTube video"
                                allowFullScreen
                              />
                            ) : (
                              <video controls className="w-full rounded-lg">
                                <source src={vid} type="video/mp4" />
                              </video>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default ItineraryContentCampaign;
